export const LOGIN_REQUEST = {type: "LOGIN_REQUEST"}

export const LOGIN_SUCCESS = {type: "LOGIN_SUCCESS"}

export const LOGOUT_REQUEST = {type: "LOGOUT_REQUEST"}

export const ME_SUCCESS = {type: "ME_SUCCESS"}